import type {ReactNode} from 'react';
import {memo, useCallback, useMemo, useState} from 'react';
import {useLocalStorage} from 'usehooks-ts';

import {NavigationContext} from './context.js';

export const NAVIGATION_STORAGE_KEY = 'vtx-navigation';

type NavigationProviderProps = {
  children: ReactNode;
};

export const NavigationProvider = memo(function NavigationProvider({
  children,
}: NavigationProviderProps) {
  const [collapsed, setCollapsedStorage] = useLocalStorage(
    NAVIGATION_STORAGE_KEY,
    false
  );
  const [widthTransition, setWidthTransition] = useState(false);

  const setCollapsed = useCallback(
    (nextCollapsed: boolean) => {
      setCollapsedStorage(nextCollapsed);
    },
    [setCollapsedStorage]
  );

  const contextValue = useMemo(
    () => ({
      collapsed,
      setCollapsed,
      widthTransition,
      setWidthTransition,
    }),
    [collapsed, setCollapsed, widthTransition]
  );

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
});
